<template>
  <div class="rubber-hysteresis-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>能量损耗 = 循环面积 | 拉伸生热原理$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Force-Elongation Graph -->
          <g transform="translate(50, 200)">
             <!-- Axis -->
             <line x1="0" y1="0" x2="300" y2="0" stroke="#888" />
             <line x1="0" y1="0" x2="0" y2="-160" stroke="#888" />
             <text x="310" y="5" fill="#888" font-size="8">伸长量 ΔL</text>
             <text x="-35" y="-150" fill="#888" font-size="8">拉力 F</text>

             <!-- Hysteresis Loop -->
             <!-- Loading -->
             <path :d="loadingCurve" fill="none" stroke="#ff4757" stroke-width="2" />
             <!-- Unloading -->
             <path :d="unloadingCurve" fill="rgba(255, 71, 87, 0.2)" stroke="#ff4757" stroke-width="2" stroke-dasharray="2" />
             
             <!-- Shaded area (Heat loss) -->
             <text x="100" y="-80" fill="rgba(255, 71, 87, 0.6)" font-size="10" v-if="cycle > 0">内能增加 (发热)</text>
          </g>

          <!-- Physical Rubber Model -->
          <g transform="translate(150, 40)">
             <rect x="0" y="0" width="100" height="20" fill="#333" stroke="#666" />
             <rect :x="0" :y="20" :width="100" :height="20 + extension" fill="#ff4757" opacity="0.8" rx="5" />
             <text x="110" y="30" fill="#ff4757" font-size="8">橡胶分子链纠缠</text>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>能量转化效率: {{ (100 - cycle/2).toFixed(1) }}%</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>拉伸强度 Control</label>
             <el-slider v-model="extension" :min="0" :max="100" size="mini" @change="addCycle"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当你拉伸一块橡胶并释放时，释放过程中输出的能量总比拉伸时输入的能量少。在 F-ΔL 图像中，加载和卸载曲线包围的面积就是**弹性滞后损耗**。这是因为橡胶的长链分子在位移时会发生剧烈的内部摩擦，将机械能转化为**内能**。长期剧烈形变的轮胎会发烫甚至爆裂，正是此物理效应造成的。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RubberHysteresisViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      extension: 0,
      cycle: 0
    }
  },
  computed: {
    loadingCurve() {
       let d = "M 0 0 ";
       for (let i = 0; i <= this.extension; i++) {
          d += `L ${i * 3} ${-Math.pow(i, 1.2)} `;
       }
       return d;
    },
    unloadingCurve() {
       let d = `M ${this.extension * 3} ${-Math.pow(this.extension, 1.2)} `;
       for (let i = this.extension; i >= 0; i--) {
          d += `L ${i * 3} ${-Math.pow(i, 1.3) * 0.9} `;
       }
       return d;
    }
  },
  methods: {
    addCycle() {
       if (this.extension > 50) this.cycle += 5;
    }
  }
}
</script>

<style scoped lang="scss">
.rubber-hysteresis-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
